import { ApiClient } from "./client";
import { GO2NFT_API_URL } from "@config/config";

export const apiClient = new ApiClient({ baseUrl: GO2NFT_API_URL });
